import type { PropsWithChildren } from 'react';
import { useLayoutEffect, useMemo, useRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { useBoolean } from '@/_shared';

import { StickyHeaderContext } from './context';

export function StickyContainer({
  children,
  className,
  threshold = 5,
}: PropsWithChildren<{ className?: string; threshold?: number }>) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isSticky, sticky] = useBoolean(false);

  const value = useMemo(() => ({ isSticky }), [isSticky]);

  useLayoutEffect(() => {
    if (ref.current) {
      const element = document.getElementById('scrl');
      const scrlElement = element || window;

      const fixedHeader = () => {
        if (ref.current) {
          let scrollPosition = 0;
          if (scrlElement instanceof Window) {
            scrollPosition = scrlElement.scrollY;
          } else {
            scrollPosition = scrlElement.scrollTop;
          }
          if (scrollPosition > threshold) {
            ref.current.classList.remove('border-transparent');
            ref.current.classList.add(
              'border-c-border',
              'shadow-md'
              // 'bg-white',
              // 'dark:bg-gray-950'
            );
            sticky.setTrue();
          } else {
            ref.current.classList.add('border-transparent');
            ref.current.classList.remove(
              'border-c-border',
              'shadow-md'
              // 'bg-white',
              // 'dark:bg-gray-950'
            );
            sticky.setFalse();
          }
        }
      };

      scrlElement.addEventListener('scroll', fixedHeader);
      fixedHeader();
      return () => {
        scrlElement.addEventListener('scroll', fixedHeader);
      };
    }
    return undefined;
  }, [sticky, threshold]);

  return (
    <StickyHeaderContext value={value}>
      <div
        ref={ref}
        className={twMerge(
          'bg-c-background sticky top-14 z-11 border-b border-transparent transition-shadow duration-300 ease-out',
          className
        )}
      >
        {children}
      </div>
    </StickyHeaderContext>
  );
}
